<template>
	<AlertCardWrapper @action-button-click="actionButtonClick" :actionTitle="actionTitle" :alert="alert" :titleArr="titleArr" />
</template>

<script>
import AlertTypeBaseMixin from '../mixins/AlertTypeBaseMixin';
import { getProject } from '@/store/modules/projects/getters';
import { getProjectData } from '@/store/modules/projects/actions';
import { mapGettersShorthand, mapActionsShorthand } from '@/store/utils/mappers';
export default {
	name: 'ProjectCollaboratedGoToProject',
	mixins: [AlertTypeBaseMixin],
	computed: {
		...mapGettersShorthand({ getProject }),
		actionTitle() {
			return 'Open space';
		},
		titleArr() {
			return [
				{ text: 'You were added as a collaborator to' },
				{ text: `${this.project?.title ? `space "${this.project?.title}"` : 'a space'}`, isBold: !!this.project?.title },
			];
		},
		project() {
			return this.getProject(this.alert.entity_id);
		},
	},
	methods: {
		...mapActionsShorthand({ getProjectData }),
		actionButtonClick() {
			if (this.project) {
				this.$router.push({ name: 'Features', params: { pID: this.project.id } });
			}
			this.markAlertAsCompleted();
		},
	},
	async created() {
		if (this.project) {
			await this.getProjectData({ id: this.project.id });
		}
	},
};
</script>

<style scoped lang="scss"></style>
